import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { Link } from 'react-router-dom';
import { useLocations } from '../../../../data/Locations'
import { deleteLocation } from '../../../../data/Locations/deleteLocation';

import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

export const LocationMap = (() => {
    const LocationsQuery = useLocations()
    const [locations, setLocations] = useState()
    const [map, setMap] = useState(null)
    const [searchAddress, setSearchAddress] = useState("Erie PA")
    const [searchRadius, setSearchRadius] = useState(10)
    const [locationLat, setLocationLat] = useState(42.129223)
    const [locationLon, setLocationLon] = useState(-80.085060)
    const [center, setCenter] = useState()
    const [searchAddressMarker, setSearchAddressMarker] = useState()
    const [locationMarkerArray, setLocationMarkerArray] = useState([])
    const [locationArray, setLocationArray] = useState([])
    const [theInfoWindow, setTheInfoWindow] = useState()
    // const [infoWindowData, setInfoWindowData] = useState()

    const time = useRef(0);
    const timer = useRef(false);
    const [timeoutExceeded, setTimeoutExceeded] = useState(false)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyD4pfCExrP2jhurv5J544dFFl7UpoPDGVk"
    })


    const queryClient = useQueryClient()

    const { mutate: trashLocation } = useMutation(deleteLocation, {
        onSettled: ((data) => {
            queryClient.invalidateQueries('locations')
            alert("Item successfully deleted")
        }),
        onError: ((error) => {
            alert("There was an error: ", error)
        })
    })

    // Map constants
    const containerStyle = {
        width: '80%',
        height: '400px',
        marginLeft: '10%',
        marginRight: '10%',
    };

    const oneMileLat = 0.0144927536231884
    const oneMileLon = 0.0144927536231884
    // const searchRadius = 100
    const MAX_LOCATIONS = 25


    const onLoad = useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds();
        map.fitBounds(bounds);
        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    // Timer
    useEffect(() => {
        timer.current = setInterval(function() {
        if(time.current > 5) {
            // trigger a re-render by setting limitExceeded to true
            setTimeoutExceeded(true);
            clearInterval(timer.current);
        } else {
            ++time.current;
        }
        }, 1000);

        return () => clearInterval(timer.current);
      }, []);
      

    useEffect(() => {
        console.log("theInfoWindow is now ",theInfoWindow)
    },[theInfoWindow])


    useEffect(() => {
        findLocationsWithinRadius(locationLat,locationLon)
    },[locationLat,locationLon])


    useEffect(() => {
        if(map && center && searchRadius) {
            findLocationsWithinRadius(locationLat,locationLon)
            const circle = new window.google.maps.Circle({
                center: center,
                radius: searchRadius*1609.34,
                fillOpacity: 0,
                strokeOpacity: 0,
                fillColor: "#FF0000",
                map: map
            });
            map.fitBounds(circle.getBounds());
        }
    },[map,center,searchRadius])

    const findLocationsWithinRadius = (lat,lng) => {
        console.log("READY TO SEARCH FOR NEARBY LOCATIONS")
        console.log(lat)
        console.log(lng)
        console.log(searchRadius)

        const theLocations = []
        locations?.forEach(location => {
            if(location.lat > lat-oneMileLat*searchRadius && location.lat < lat+oneMileLat*searchRadius && location.lon > lng-oneMileLon*searchRadius && location.lon < lng+oneMileLon*searchRadius) {
            // if(location.lat > locationLat-oneMileLat*searchRadius && location.lat < locationLat+oneMileLat*searchRadius && location.lon > locationLon-oneMileLon*searchRadius && location.lon < locationLon+oneMileLon*searchRadius) {
                theLocations.push(location)
            }
        })
        setLocationMarkerArray([...theLocations])
        setLocationArray([...theLocations])
        console.log("theLocations = ", theLocations)
        
        addLocationMarkers(theLocations)
    }





    const addLocationMarkers = (locationsToShow) => {
        const allMarkers = []

        // Erase previous markers
        locationMarkerArray?.forEach(aMarker => {
            aMarker.setMap(null) // Need fail safe
        })

        locationsToShow?.forEach(location => {
            // const coords = results.features[i].geometry.coordinates;
            const latLng = new window.google.maps.LatLng(location.lat, location.lon);

            const marker = new window.google.maps.Marker({
                position: latLng,
                map: map,
                title: location.name
            });

            
            marker.addListener("click", () => {
                if(theInfoWindow) {
                    console.log("Closing infoWindow ",theInfoWindow)
                    theInfoWindow.close()
                }

                let locationString = `${location.street} ${location.city} ${location.state} ${location.zip}`
                if (location.street === 'Confidential location. Please call.') {
                    locationString = `${location.city} ${location.state} ${location.zip}`
                }
                const directionsUrl = encodeURI(`https://www.google.com/maps/dir/${searchAddress}/${locationString}`)

                const infowindow = new window.google.maps.InfoWindow({
                    content: `<div style="font-size:16px;">${location.name}</div><div>${location.street}</div><div>${location.city} ${location.state} ${location.zip}</div><div>${location.phone}</div><a href=${directionsUrl} target="_blank" rel="norefferer">Directions</a>`,
                });
                setTheInfoWindow(infowindow)
                infowindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false,
                });
                // setInfoWindowData({infowindow:infowindow,})
            });

            allMarkers.push(marker)
        })

        setLocationMarkerArray([...allMarkers])
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        // get lat/lon from address
        const encodedURI = encodeURI(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchAddress}&key=AIzaSyD4pfCExrP2jhurv5J544dFFl7UpoPDGVk`)
        console.log(encodedURI)
        fetch(encodedURI)
        .then( resp => resp.json())
        .then((data)=> {
            console.log(data)
            if(data?.status === "OK") {
                const lat = parseFloat(data.results[0].geometry.location.lat);
                const lng = parseFloat(data.results[0].geometry.location.lng)
                setLocationLat(lat)
                setLocationLon(lng)
                const theCenter = new window.google.maps.LatLng(lat,lng);
                setCenter(theCenter)
                console.log("theCenter = ",theCenter)
                // findLocationsWithinRadius(lat,lng)
            } else {
                console.log("Invalid search address")
            }
        })
    }

    useEffect(() => {
        if (isLoaded) {
            console.log("searchAddressMarker = ", searchAddressMarker)
            
            // Removes previous marker
            if(searchAddressMarker) {
                searchAddressMarker.setMap(null)
            }
            console.log(`Adding Marker to ${locationLat}, ${locationLon}`)
            const marker = new window.google.maps.Marker({
                position: center,
                map: map,
                icon: {
                    url: "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                }
            });
            setSearchAddressMarker(marker)

            // findLocationsWithinRadius(locationLat,locationLon)
        }
    },[center])

    useEffect(() => {
        if(isLoaded) {
            const theCenter = new window.google.maps.LatLng(42.129223,-80.085060)
            setCenter(theCenter)
            console.log("MAP IS LOADED")
        } else {
            console.log("MAP IS NOT LOADED")
        }
    },[isLoaded])

    useEffect(() => {
        console.log("Center updatd to ",center)
    },[center])

    useEffect(() => {
        console.log("Search Radius is ",searchRadius)
    },[searchRadius])

    useEffect(() => {
        setLocations(LocationsQuery.data)
    }, [LocationsQuery])

    if (LocationsQuery.isLoading || !timeoutExceeded) return (
        <div class="ghost-creativ-map-wrapper" id="advanced_iframe" style={{marginTop:20, textAlign:'center'}}>
            "Loading Location Data..."
        </div>
    );
    if (LocationsQuery.error) return "An error has occurred loading the locations: " + LocationsQuery.error.message;

    return isLoaded ? (
        // <div className='h-screen overflow-hidden'>
        <div class="ghost-creativ-map-wrapper" id="advanced_iframe">
            <div>
                <form style={{marginLeft: '10%',marginRight: '10%',}} onSubmit={handleSubmit}>
                    <label style={{margin:8}}> Address / ZIP: </label>
                    <input style={{width:"80%", margin:8}} type="text" value={searchAddress} name="address" onChange={(e) => setSearchAddress(e.target.value)} />
                    <br />
                    <label style={{margin:8}}> Within: </label>
                    <select style={{margin:8}} name="distanceSelect" onChange={(e) => setSearchRadius(parseInt(e.target.value))} value={searchRadius}>
                        <option value="5" selected>5 miles</option>
                        <option value="10">10 miles</option>
                        <option value="15">15 miles</option>
                        <option value="20">20 miles</option>
                        <option value="25">25 miles</option>
                        <option value="30">30 miles</option>
                        <option value="50">50 miles</option>
                        <option value="100">100 miles</option>
                    </select>
                    <input style={{padding:10}} type="submit" value="Find Locations" />
                </form>
                
                <div>
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={10}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                        unitSystem={window.google.maps.UnitSystem.IMPERIAL}
                    >
                        { 
                            /* Child components, such as markers, info windows, etc. */ 
                            // locations?.forEach(location => {
                            //     // const coords = results.features[i].geometry.coordinates;
                            //     const latLng = new window.google.maps.LatLng(location.lat, location.lon);

                            //     const marker = new window.google.maps.Marker({
                            //         position: latLng,
                            //         map: map,
                            //         title: location.name
                            //     });

                            //     const infowindow = new window.google.maps.InfoWindow({
                            //         content: `<div style="font-size:16px;">${location.name}</div><div>${location.street}</div><div>${location.city} ${location.state} ${location.zip}</div><div>${location.phone}</div>`,
                            //     });

                            //     marker.addListener("click", () => {
                            //         console.log("CLICKED THE MARKER")
                            //         infowindow.open({
                            //             anchor: marker,
                            //             map,
                            //             shouldFocus: false,
                            //         });
                            //     });
                            // })
                        }
                        <></>
                    </GoogleMap>
                </div>
                <div style={{marginLeft:"10%",marginRight:"10%"}}>
                    {
                        locationArray?.map(location => {
                            let locationString = `${location.street} ${location.city} ${location.state} ${location.zip}`
                            if (location.street === 'Confidential location. Please call.') {
                                locationString = `${location.city} ${location.state} ${location.zip}`
                            }
                            const directionsUrl = encodeURI(`https://www.google.com/maps/dir/${searchAddress}/${locationString}`)
                            return (
                                <div style={{padding:10, margin:8,border:"1px solid darkgray", borderRadius:8}}>
                                    <div style={{fontSize:20}}>{location.name}</div>
                                    <div>{location.street}</div>
                                    <div>{location.city}, {location.state} {location.zip}</div>
                                    <div>{location.phone}</div>
                                    <a href={directionsUrl} target="_blank" rel="norefferer">Directions</a>
                                </div>
                            )
                        })
                    }
                    <div></div>
                </div>
            </div>
        </div>
    ) : <></>
})


{
/* 
// OLD CODE FROM WORDPRESS
<div id="ghostCreativMap-container" style="height:1200px">
  <iframe id="ghostCreativMap-iframe" style="width:100%; height:auto;" src="https://safejourneyerie.web.app/locationMap"></iframe>
</div> 

// PREVIOUS MAP SHORTCODE
[slplus]
*/
}